<!-- eslint-disable vue/html-indent -->
<template>
    <div
        class="planCard mobile:p-4 tablet:p-4 mobile:mx-1 mobile:my-2 tablet:my-3 tablet:mx-4 flex flex-col justify-start items-start gap-2 rounded-2xl shadow-[0px_0px_10px_0px_#00000026;] bg-white">
        <div class="flex items-center !justify-between py-2 !w-full">
            <div class="flex justify-start items-center gap-1">
                <div class="w-1.5 h-1.5 rounded-full bg-blueLight-100"></div>
                <div class="w-6 h-1.5 rounded-full bg-blueLight-100"></div>
                <p class="text-lg font-semibold font-roboto pl-2 m-0 text-blueLight-100">New Bundle</p>
            </div>
            <div>
                <slot name="action"></slot>
            </div>
        </div>
        <h4 class="flex items-center mobile:text-lg largeDesktop:text-[22px] font-roboto font-normal m-0 !w-full text-left  min-h-16 text-[#333333]">
            {{ plan.bundle_name.length
                > 80 ? plan.bundle_name.slice(0, 10) + '...' : plan.bundle_name }}</h4>
        <span class="m-0 mobile:text-base largeDesktop:text-lg font-roboto font-medium text-red-400 !leading-[0.5]">{{
            plan.months + ' months plan' }}</span>
        <h2 class="mobile:text-3xl tablet:text-3xl largeDesktop:text-4xl font-roboto font-bold m-0 text-[#333333]">${{
            $helper.formatAmount(plan.amount) }}<span class="text-xl">/mo</span></h2>
        <div class="py-1 w-full">
            <div class="flex flex-col gap-2.5 pr-2 w-full h-[320px] tablet:h-[280px] largeDesktop:h-[330px] m-0 overflow-y-auto customScrollbar planDescription">
                <div v-for="(item, index) in plan.plans" :key="index" class="w-full flex items-start gap-2 p-2.5 rounded-xl bg-[#F1F1F180]">

                    <!-- <img v-if="item.trade_name == 'HVAC'" src="../../assets/images/bundleicon-01.png"
                        class="w-14 h-14 largeDesktop:w-20 largeDesktop:h-20 object-contain" alt="icon">

                     <img  v-else-if="item.trade_name == 'Electric'" src="../../assets/images/bundleicon-02.png"
                        class="w-14 h-14 largeDesktop:w-20 largeDesktop:h-20 object-contain" alt="icon">

                    <img  v-else-if="item.trade_name == 'Plumbing'" src="../../assets/images/bundleicon-03.png"
                        class="w-14 h-14 largeDesktop:w-20 largeDesktop:h-20 object-contain" alt="icon"> -->

                    <div class="flex flex-col items-start gap-1.5 largeDesktop:gap-2 pt-1">
                        <div
                            class="w-fit text-xs largeDesktop:text-sm font-normal px-2.5 largeDesktop:px-3 rounded-full shadow-[0px_0px_10px_0px_#00000026;] text-purple-100 bg-white">
                            {{ item.trade_name }}
                        </div>
                        <h4
                            class="text-left text-base largeDesktop:text-lg !font-normal font-roboto !leading-[20px] mb-0 text-black-100">
                            {{ item.plan_name }}</h4>
                    </div>
                </div>
                <!-- <div class="w-full flex items-start gap-2 p-2.5 rounded-xl bg-[#F1F1F180]">

                    <img src="../../assets/images/bundleicon-02.png"
                        class="w-14 h-14 largeDesktop:w-20 largeDesktop:h-20 object-contain" alt="icon">

                    <div class="flex flex-col items-start gap-1.5 largeDesktop:gap-2 pt-1">
                        <div
                            class="w-fit text-xs largeDesktop:text-sm font-normal px-2.5 largeDesktop:px-3 rounded-full shadow-[0px_0px_10px_0px_#00000026;] text-purple-100 bg-white">
                            Electric
                        </div>
                        <h4
                            class="text-left text-base largeDesktop:text-lg !font-normal font-roboto !leading-[20px] mb-0 text-black-100">
                            Electric Repair and Maintenance Plan</h4>
                    </div>
                </div>
                <div class="w-full flex items-start gap-2 p-2.5 rounded-xl bg-[#F1F1F180]">

                    <img src="../../assets/images/bundleicon-03.png"
                        class="w-14 h-14 largeDesktop:w-20 largeDesktop:h-20 object-contain" alt="icon">

                    <div class="flex flex-col items-start gap-1.5 largeDesktop:gap-2 pt-1">
                        <div
                            class="w-fit text-xs largeDesktop:text-sm font-normal px-2.5 largeDesktop:px-3 rounded-full shadow-[0px_0px_10px_0px_#00000026;] text-purple-100 bg-white">
                            Plumbing
                        </div>
                        <h4
                            class="text-left text-base largeDesktop:text-lg !font-normal font-roboto !leading-[20px] mb-0 text-black-100">
                            External Server and Septic and
                            External Water Line Repair DELUXE</h4>
                    </div>
                </div> -->
            </div>
        </div>
        <span v-if="plan.quantity == 0" @click="updateCounter('increment')"
            class="group px-3 py-1.5 flex justify-center items-center mx-auto gap-1 text-base rounded-full cursor-pointer border-[1px] !border-secondary-100 text-secondary-100 hover:bg-secondary-100 hover:text-white">
            <img src="../../assets/images/cart-check.png" class="w-7 h-7 object-contain group-hover:hidden" alt="icon">
            <img src="../../assets/images/cart-check-white.png"
                class="w-7 h-7 object-contain !hidden group-hover:!block" alt="icon">
            Select this bundle
        </span>

        <div v-else class="flex w-full justify-center items-center gap-4">
            <quantityCounter v-if="plan.is_show_quantity == 1" :quantity="plan.quantity"
                @update-counter="updateCounter" />
            <button v-else type="button" @click="updateCounter('remove')"
                class="group !h-10 !w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-[#F67280] !bg-transparent hover:!bg-[#F67280]">
                <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                    class="!w-7 !h-7 group-hover:hidden">
                <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                    class="!w-7 !h-7 hidden group-hover:!block">
            </button>
            <img src="../../assets/images/cart-icon-with-bg.svg" alt="Cart Icon" class="!w-10 !h-10">
        </div>
    </div>
</template>

<script>
import quantityCounter from '../partialComponent/quantityCounter.vue';

export default {

    components: {
        quantityCounter,
    },
    props: {
        plan: Object,
        isSelected: Boolean,
        updateCart: Function,
        updateCard: Object,
    },
    data() {
        return {
            localObject: null
        }
    },

    watch: {
        updateCard: function (data) {
            if (data && this.localObject) {
                this.plan.quantity = this.localObject.quantity
            }
            // this.localObject = null
        },
    },

    methods: {
        updateCounter(option) {
            this.localObject = JSON.parse(JSON.stringify(this.plan))
            if (option == "increment") {
                this.localObject.quantity++
            } else if (option == "decrement") {
                if (this.localObject.quantity > 1) {
                    this.localObject.quantity--
                } else {
                    this.localObject.quantity = 0
                }
            } else {
                this.localObject.quantity = 0
            }

            this.updateCart(option, {
                id: this.localObject.id,
                quantity: this.localObject.quantity
            })
        },
    }

}
</script>

<style scoped>
.carousel__slide--active .planCard {
    border: 1px solid transparent;
}

</style>